<template>
  <form-layout>
    <template slot="heading">
      <h5>パスワード設定</h5>
    </template>
    <Set/>
  </form-layout>
</template>

<script>
import FormLayout from '@/views/FormLayout.vue';
import Set from '@/components/auth/Set.vue';

export default {
  name: 'SetPassword',
  components: { FormLayout, Set },
};
</script>

<style scoped>

</style>
